import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import clsx from 'clsx';
import React, { useEffect, useCallback } from 'react';
import { useTUXRadioContext } from './TUXRadio.context.js';
import { useControlled } from '../../hooks/useControlled.js';

var TUXRadio = function TUXRadio(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color,
      checked = _ref.checked,
      _ref$defaultChecked = _ref.defaultChecked,
      defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      name = _ref.name,
      _ref$value = _ref.value,
      selfValue = _ref$value === void 0 ? '' : _ref$value;

  var _useTUXRadioContext = useTUXRadioContext(),
      inGroup = _useTUXRadioContext.inGroup,
      value = _useTUXRadioContext.value,
      disabledAll = _useTUXRadioContext.disabledAll,
      updateState = _useTUXRadioContext.updateState;

  var _useControlled = useControlled({
    value: checked,
    defaultValue: defaultChecked
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      internalChecked = _useControlled2[0],
      setInternalChecked = _useControlled2[1];

  var isDisabled = disabled || disabledAll;

  useEffect(function () {
    if (inGroup) {
      setInternalChecked(selfValue === value);
    }
  });
  var changeHandler = useCallback(function (e) {
    if (isDisabled) {
      return;
    }

    if (inGroup) {
      updateState && updateState(selfValue);
    }

    setInternalChecked(e.target.checked);
    onChange && onChange(e);
  }, [isDisabled, onChange, inGroup, updateState, selfValue, setInternalChecked]);
  var opacity = isDisabled ? 0.34 : 1;
  return /*#__PURE__*/React.createElement("label", {
    className: clsx('inline-block box-border', {
      'medium': 'w-24 h-24',
      'small': 'w-16 h-16'
    }[size])
  }, /*#__PURE__*/React.createElement("input", {
    className: "hidden",
    type: "radio",
    name: name,
    value: selfValue,
    checked: internalChecked,
    disabled: isDisabled,
    onChange: changeHandler
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "w-full h-full TUXRadio__icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 12a11 11 0 11-22 0 11 11 0 0122 0z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeOpacity: opacity,
    className: clsx({
      'default': 'text-color-LineSecondary',
      'const': 'text-color-ConstTextInverse'
    }[color]),
    opacity: internalChecked ? 0 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 12a11 11 0 11-22 0 11 11 0 0122 0z",
    className: "text-color-Primary",
    stroke: "currentColor",
    strokeWidth: size === 'medium' ? 2 : 1.33,
    strokeLinecap: "square",
    strokeOpacity: opacity,
    opacity: internalChecked ? 1 : 0
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20a8 8 0 100-16 8 8 0 000 16z",
    className: "text-color-Primary",
    fill: "currentColor",
    fillOpacity: opacity,
    opacity: internalChecked ? 1 : 0
  })));
};

export { TUXRadio };
//# sourceMappingURL=TUXRadio.js.map
